const styles = {
  scroll: {
    height: '60vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { display: 'none' },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  linear: {
    flex: 1,
    mr: 1,
  },
  qrcode: {
    fontSize: 150,
  },
  hideInput: {
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
  },
  txtqtd: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  headerContainer: {
    marginBottom: '.5em',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'space-between',
  },
  backBtn: {
    '&&': {
      marginRight: '.5em',
    },
  },
  title: {
    flex: 1,
    padding: '1px 0',
  },
};

export default styles;
